import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import "./TableRow.css";
import "./index.css"

const TableRow = ({ i, row }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Date and Time formatting functions from your second component are kept to preserve the layout.
  const getDisplayDate = () => {
    const openDateObj = new Date(row.open_date);
    const today = new Date();
    const tomorrow = new Date(today);
    today.setHours(0, 0, 0, 0);
    tomorrow.setDate(today.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);

    if (openDateObj.toDateString() === today.toDateString()) return "Today";
    if (openDateObj.toDateString() === tomorrow.toDateString()) return "Tomorrow";

    return openDateObj.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const getDisplayTime = () => {
    const openDateObj = new Date(row.open_date);
    return openDateObj.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  };

  // ✅ **FUNCTIONALITY MERGED**
  // This section incorporates the dynamic odds logic from your first component.
  // It creates an interleaved array of back and lay prices.
  const odds = [];
  for (let runnerIndex = 0; runnerIndex < 3; runnerIndex++) {
    const runner = row?.marketTypes?.[0]?.marketRunners?.[runnerIndex];
    // Push the back price (for the blue box)
    odds.push(runner?.back_1_price || "0");
    // Push the lay price (for the pink box)
    odds.push(runner?.lay_1_price || "0");
  }

  return (
    <>
      <div className="md:flex  border-b border-gray-400  bg-[#FFFF] " key={i}>
        {isMobile ? (
          // ✅ Mobile Layout
          <Link
            to={`/matchupdates/${row.event_id}/${row.is_inplay === "True" ? "Inplay" : "Going Inplay"}`}
            className="md:flex md:items-center md:justify-between w-full "
          >
            <div className=" match-title flex justify-between items-center w-full">
              <span className="mr-3 relative left-[5px]">{row?.event_name}</span>
              <div className=" match-icons">
                {row?.is_inplay === "True" && (
                  <div className="" style={{ marginRight: 8 }}>
                    <span className="cool-link" style={{ display: "inline-block", color: "#03b37f", textDecoration: "none", position: "relative", fontSize: "11px" }}>
                      LIVE
                    </span>
                  </div>
                )}
                {row?.is_tv == "True" && (<img className="w-5 mr-1" src="/Images/tv.svg" alt="tv" />)}
                {row?.is_fancy == "True" && (<img className="w-[35px] h-[15px] mr-1" src="/Images/fancy-icon1.svg" alt="fancy" />)}
                {row?.is_bm == "True" && (<img className="w-[35px] h-[15px] mr-1" src="/Images/bm-icon1.svg" alt="bm" />)}
              </div>
            </div>
            <div className=" flex w-full ">
              <div className="text-[#545454] flex  text-[14px] font-normal ">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.879 103.461" className="w-4 h-4 fill-gray-500" aria-hidden="true" >
                  <path d="M85.275,18.308c9.75,1.166,18.492,5.614,25.09,12.21c7.732,7.732,12.514,18.415,12.514,30.212 c0,11.799-4.781,22.482-12.514,30.215s-18.416,12.516-30.215,12.516s-22.48-4.783-30.213-12.516S37.422,72.529,37.422,60.73 c0-11.798,4.783-22.48,12.515-30.212c7.083-7.083,16.643-11.691,27.266-12.415v-7.167c0-0.109,0.006-0.216,0.014-0.323h-8.004 c-1.313,0-2.385-1.074-2.385-2.386V2.386C66.828,1.074,67.9,0,69.213,0h24.053c1.313,0,2.387,1.074,2.387,2.386v5.841 c0,1.313-1.074,2.386-2.387,2.386h-8.004c0.01,0.106,0.014,0.214,0.014,0.323V18.308L85.275,18.308z M83.582,54.348 c2.271,1.223,3.814,3.623,3.814,6.383c0,4.002-3.244,7.248-7.246,7.248s-7.246-3.246-7.246-7.248c0-2.76,1.545-5.16,3.816-6.383 V37.744c0-1.895,1.535-3.431,3.43-3.431s3.432,1.536,3.432,3.431V54.348L83.582,54.348z M10.527,84.598 c-1.895,0-3.431-1.537-3.431-3.432s1.536-3.43,3.431-3.43h19.378c1.895,0,3.43,1.535,3.43,3.43s-1.536,3.432-3.43,3.432H10.527 L10.527,84.598z M3.43,64.424c-1.895,0-3.43-1.535-3.43-3.43s1.536-3.432,3.43-3.432h22.447c1.894,0,3.43,1.537,3.43,3.432 s-1.536,3.43-3.43,3.43H3.43L3.43,64.424z M10.354,44.774c-1.895,0-3.43-1.536-3.43-3.43s1.536-3.431,3.43-3.431h19.229 c1.895,0,3.431,1.536,3.431,3.431s-1.536,3.43-3.431,3.43H10.354L10.354,44.774z M118.527,31.215 c1.658-3.958,1.461-8.104-0.912-10.882c-2.848-3.333-7.996-3.715-12.777-1.37C109.902,22.436,114.5,26.476,118.527,31.215 L118.527,31.215z M41.775,31.215c-1.659-3.958-1.462-8.104,0.911-10.882c2.848-3.333,7.996-3.715,12.777-1.37 C50.4,22.436,45.801,26.476,41.775,31.215L41.775,31.215z M105.514,35.369c-6.49-6.491-15.457-10.505-25.363-10.505 c-9.904,0-18.872,4.015-25.362,10.505c-6.491,6.49-10.505,15.458-10.505,25.362c0,9.906,4.015,18.873,10.505,25.363 S70.246,96.6,80.15,96.6c9.906,0,18.873-4.016,25.363-10.506S116.02,70.637,116.02,60.73 C116.02,50.826,112.004,41.859,105.514,35.369L105.514,35.369z" />
                </svg>
                <div className="ml-2">{getDisplayDate()}</div>
                <div className="ml-2">{getDisplayTime()}</div>
              </div>
            </div>
          </Link>
        ) : (
          // ✅ Desktop Layout
          <Link to={`/matchupdates/${row.event_id}/${row.is_inplay === "True" ? "Inplay" : "Going Inplay"}`} className="w-full">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between w-full ">
              <div className="flex items-center md:order-1 md:mt-4  md:mr-1">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.879 103.461" className="w-4 h-4 fill-gray-500" aria-hidden="true" >
                  <path d="M85.275,18.308c9.75,1.166,18.492,5.614,25.09,12.21c7.732,7.732,12.514,18.415,12.514,30.212 c0,11.799-4.781,22.482-12.514,30.215s-18.416,12.516-30.215,12.516s-22.48-4.783-30.213-12.516S37.422,72.529,37.422,60.73 c0-11.798,4.783-22.48,12.515-30.212c7.083-7.083,16.643-11.691,27.266-12.415v-7.167c0-0.109,0.006-0.216,0.014-0.323h-8.004 c-1.313,0-2.385-1.074-2.385-2.386V2.386C66.828,1.074,67.9,0,69.213,0h24.053c1.313,0,2.387,1.074,2.387,2.386v5.841 c0,1.313-1.074,2.386-2.387,2.386h-8.004c0.01,0.106,0.014,0.214,0.014,0.323V18.308L85.275,18.308z M83.582,54.348 c2.271,1.223,3.814,3.623,3.814,6.383c0,4.002-3.244,7.248-7.246,7.248s-7.246-3.246-7.246-7.248c0-2.76,1.545-5.16,3.816-6.383 V37.744c0-1.895,1.535-3.431,3.43-3.431s3.432,1.536,3.432,3.431V54.348L83.582,54.348z M10.527,84.598 c-1.895,0-3.431-1.537-3.431-3.432s1.536-3.43,3.431-3.43h19.378c1.895,0,3.43,1.535,3.43,3.43s-1.536,3.432-3.43,3.432H10.527 L10.527,84.598z M3.43,64.424c-1.895,0-3.43-1.535-3.43-3.43s1.536-3.432,3.43-3.432h22.447c1.894,0,3.43,1.537,3.43,3.432 s-1.536,3.43-3.43,3.43H3.43L3.43,64.424z M10.354,44.774c-1.895,0-3.43-1.536-3.43-3.43s1.536-3.431,3.43-3.431h19.229 c1.895,0,3.431,1.536,3.431,3.431s-1.536,3.43-3.431,3.43H10.354L10.354,44.774z M118.527,31.215 c1.658-3.958,1.461-8.104-0.912-10.882c-2.848-3.333-7.996-3.715-12.777-1.37C109.902,22.436,114.5,26.476,118.527,31.215 L118.527,31.215z M41.775,31.215c-1.659-3.958-1.462-8.104,0.911-10.882c2.848-3.333,7.996-3.715,12.777-1.37 C50.4,22.436,45.801,26.476,41.775,31.215L41.775,31.215z M105.514,35.369c-6.49-6.491-15.457-10.505-25.363-10.505 c-9.904,0-18.872,4.015-25.362,10.505c-6.491,6.49-10.505,15.458-10.505,25.362c0,9.906,4.015,18.873,10.505,25.363 S70.246,96.6,80.15,96.6c9.906,0,18.873-4.016,25.363-10.506S116.02,70.637,116.02,60.73 C116.02,50.826,112.004,41.859,105.514,35.369L105.514,35.369z" />
                </svg>
              </div>
              <div className="text-[#123344] font-bold flex text-[14px] font-normal items-center md:order-2 md:mr-2">
                <div className="ml-2">{getDisplayDate()}</div>
                <div className="ml-2">{getDisplayTime()}</div>
              </div>
              <div className="match-title md:order-3 w-full md:w-auto">{row?.event_name}</div>
              <div className="match-icons flex items-center md:order-4 mt-2 md:mt-0 md:ml-auto">
                {row?.is_inplay === "True" && (<span className="cool-link" style={{ marginRight: 8, display: "inline-block", color: "#03b37f", textDecoration: "none", position: "relative", fontSize: "11px" }}> LIVE </span>)}
                {row?.is_tv === "True" && (<img className="w-4 mr-1" src="/Images/tv.svg" alt="tv" />)}
                {row?.is_fancy === "True" && (<img className="w-8 mr-1" src="/Images/fancy-icon1.svg" alt="fancy" />)}
                {row?.is_bm === "True" && (<img className="w-9 mr-1" src="/Images/bm-icon1.svg" alt="bm" />)}
              </div>
            </div>
          </Link>
        )}

        {/* ✅ Odds section now uses the dynamic `odds` array */}
        <div className="match-odds">
          {odds.map((odd, idx) => (
            <div key={idx} className={` ${idx % 2 === 0 ? "bg-[#66d1ff]" : "bg-[#ffb4c5]"} text-sm rounded`}
              style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "6rem", height: "23px", margin: "0 1px", }} >
              <div className="odds " style={{ color: "#000", fontWeight: "bold" }}>
                {odd}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default TableRow;